/* global google */
define('views/pages/multi-account/page',['require','underscore','views/base/page','text!templates/pages/multi-account/page.ejs'],function(require) {
    'use strict';

    var _ = require('underscore'),
        PageView = require('views/base/page'),
        template = require('text!templates/pages/multi-account/page.ejs');


    var AccountsPageView = PageView.extend({
        autoRender: true,
        template: template,
        regions: {
            'accounts-summary': '',
            'accounts-tabs': '',
            'accounts-navbar': '',
            'accounts-table': ''
        },

        listen: {
        },

        events: {
        },

        windowResize: true,

        constructor: function() {
            PageView.apply(this, arguments);
        }
    });

    return AccountsPageView;
});

